var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Block } from '../block';
import { useNotionContext } from '../context';
import { Property } from './property';
import { format } from 'date-fns';
export var CollectionGroup = function (_a) {
    var _b, _c;
    var CollectionViewComponent = _a.collectionViewComponent, collection = _a.collection, collectionGroup = _a.collectionGroup, property = _a.property, schema = _a.schema, value = _a.value, hidden = _a.hidden, summaryProps = _a.summaryProps, detailsProps = _a.detailsProps, rest = __rest(_a, ["collectionViewComponent", "collection", "collectionGroup", "property", "schema", "value", "hidden", "summaryProps", "detailsProps"]);
    var recordMap = useNotionContext().recordMap;
    if (hidden)
        return null;
    var block = null;
    if (typeof value !== 'string')
        block = (_b = recordMap.block[value === null || value === void 0 ? void 0 : value.id]) === null || _b === void 0 ? void 0 : _b.value;
    var header = block ? (React.createElement(Block, { block: block, level: 2 })) : (React.createElement(Property, { schema: schema, data: [[value]], collection: collection }));
    var itemCount = 0;
    if (!isNaN(Date.parse(value))) {
        collectionGroup.blockIds.map(function (blockId) {
            var _a, _b;
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            if (!block)
                return null;
            var dateProp = (_b = block.properties) === null || _b === void 0 ? void 0 : _b[property].flat().flat()[1][1].start_date;
            var formatDate = format(new Date(dateProp), 'MMM yyy');
            if (formatDate === value)
                itemCount++;
        });
    }
    return (React.createElement("details", __assign({ open: true, className: 'notion-collection-group' }, detailsProps),
        React.createElement("summary", __assign({ className: 'notion-collection-group-title' }, summaryProps, { style: { paddingLeft: 0 } }),
            React.createElement("div", { className: 'notion-board-th-count-container' },
                header,
                React.createElement("span", { className: 'notion-board-th-count' }, !isNaN(Date.parse(value))
                    ? itemCount
                    : (collectionGroup === null || collectionGroup === void 0 ? void 0 : collectionGroup.total) || ((_c = rest === null || rest === void 0 ? void 0 : rest.blockIds) === null || _c === void 0 ? void 0 : _c.length)))),
        React.createElement("div", { className: !isNaN(Date.parse(value)) ? 'add-border-bottom' : null },
            React.createElement(CollectionViewComponent, __assign({ collection: collection, collectionGroup: collectionGroup, value: value }, rest)))));
};
//# sourceMappingURL=collection-group.js.map